import { capitalizeFirstLetter } from 'src/utils/string';
import version from '../app/version';
import template from '../ui/templates/modal/download.hbs';

class ModalDownload {
  constructor (opts) {
    const that = this;

    this.opts = $.extend(
      {
        format: null,
        contentW: null,
        contentH: null,

        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $(this.opts.wrapper)
        : $('<div class="tool-content"></div>')
    );

    this.$wrapper.append(
      template({
        display_zip_option: INKIVE.C.IS_MOBILE_APP && !window.Android,
        display_extended_options: that.opts.format != 'pdf'
      })
    );
    initEvents();

    function initEvents () {
      const dimensions = ['thumb', 'web', 'mobile'];
      let width = that.opts.contentW;
      let height = that.opts.contentH;

      // Special case, to make 72dpi
      if (width == 737 && height == 521) {
        width = 842;
        height = 595;
      }

      const aspect = width / height;

      that.opts.format == 'png' && disableQualitySelection();
      initCheckbox();

      setDefaultValues('rangeCurrent');
      setDefaultValues('thumb', 110);
      setDefaultValues('mobile', 600);
      setDefaultValues('web', 800);

      _.each(dimensions, setOnToggled);
      _.each(_.union(['rangeCurrent'], dimensions), setOnChange);

      function disableQualitySelection () {
        that.$wrapper.find('#quality-section').addClass('disabled');
      }

      function initCheckbox () {
        that.$wrapper
          .find('.ui-dropdown .input-icon')
          .on('click', function (event) {
            $(event.target).parents('.ui-dropdown').find('ul').toggle();
          });

        that.$wrapper.find('a.quality').on('click', function () {
          that.$wrapper.find('a.quality').removeClass('active');
          $(this).addClass('active');
        });
      }

      function setDefaultValues (name, limit) {
        const className = '.' + name + 'Dimensions';

        const thisWidth = limit && width > limit ? limit : width;

        const thisHeight =
          limit && width > limit ? parseInt(limit / aspect) : height;

        that.$wrapper.find(className + '[data-type="width"]').val(thisWidth);
        that.$wrapper.find(className + '[data-type="height"]').val(thisHeight);
      }

      function setOnToggled (name) {
        const attName = 'is' + capitalizeFirstLetter(name);
        const className = '.' + name + 'Dimensions';

        that.$wrapper
          .find('[type=checkbox][name="' + attName + '"]')
          .on('change', function (event) {
            that.$wrapper.find(className).toggleClass('disabled');
          });
      }

      function setOnChange (name) {
        name += 'Dimensions';
        that.$wrapper.find('.' + name).change(function (e) {
          updateSize($(this), name);
        });
      }

      function updateSize ($elem, clazz) {
        let val = parseInt($elem.val());
        const type = $elem.attr('data-type');

        if (val < 16) val = 16;
        if (val > 3000) val = 3000;

        const width = type == 'width' ? val : parseInt(val / aspect);
        const height = type != 'width' ? val : parseInt(val / aspect);

        that.$wrapper.find('.' + clazz + '[data-type="width"]').val(width);
        that.$wrapper.find('.' + clazz + '[data-type="height"]').val(height);
      }
    }
  }

  getFormHtml () {
    return this.$wrapper;
  }

  download (callback) {
    INKIVE.Helpers.DownloadProcedure.execute(
      this.$wrapper,
      this.opts,
      callback
    );
  }
}

module.exports = ModalDownload;
